const LEGAL_LINKS = [
  { label: 'Términos',              href: 'https://ecocont.pe/terminos' },
  { label: 'Privacidad',            href: 'https://ecocont.pe/privacidad' },
  { label: 'Libro de Reclamaciones', href: 'https://libro-reclamaciones.ecocont.pe/' },
];

/**
 * Footer del área autenticada — solo desktop (`< lg` usa MobileBottomNav).
 * El badge de build (`__GIT_COMMIT__`/`__GIT_DATE__`) se inyecta en build/dev
 * time vía `define` en vite.config.ts, igual que en EcoPlan.
 */
export function Footer() {
  return (
    <footer className="shrink-0 border-t border-border bg-background/80 backdrop-blur-xs px-6 py-3 hidden lg:flex flex-wrap items-center justify-between gap-x-6 gap-y-1">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-[11px] text-muted-foreground">
        <span>© {new Date().getFullYear()} ECOCONT</span>
        {LEGAL_LINKS.map(link => (
          <span key={link.href} className="flex items-center gap-x-3">
            <span className="text-muted-foreground/30">·</span>
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground hover:underline transition-colors"
            >
              {link.label}
            </a>
          </span>
        ))}
      </div>

      <div className="flex items-center gap-2 text-[11px] text-muted-foreground/60 font-mono">
        <span
          className="inline-flex items-center gap-1 bg-muted rounded px-1.5 py-0.5 text-[10px]"
          title="Versión desplegada"
        >
          <span>⬡</span>
          {__GIT_COMMIT__}
        </span>
        <span>{__GIT_DATE__}</span>
      </div>
    </footer>
  );
}
